module.exports = __webpack_public_path__ + "media/images/audio-warning-icon-36431470ca4088b6ad9b098af89c03b2521f4ed31629274ca52f764f6fbfafdc.svg";